<app-header
    [clicked]="clickedOutside"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>

<div>
    <!-- Banner Section -->
    <app-about-us-banner
        (changeMegaMenuCondition)="changeMenuCondition($event)"
    ></app-about-us-banner>

    <!-- About Content -->
    <app-about-us-content
        (changeMegaMenuCondition)="changeMenuCondition($event)"
    ></app-about-us-content>

    <!-- Business Grow -->
    <app-about-us-business-grow
        (changeMegaMenuCondition)="changeMenuCondition($event)"
    ></app-about-us-business-grow>

    <!-- Steps -->
    <app-product-steps
        (changeMegaMenuCondition)="changeMenuCondition($event)"
        #productSteps
        [isAboutUs]="true"
        [selectedLanguage]="selectedLanguage"
        (clickEligibility)="onClickEligibility()"
    ></app-product-steps>

    <!-- Financial Advisory -->
    <div
        class="tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-justify-start tw-bg-[#F7F8FA] tw-gap-8 lg:tw-gap-12 tw-mt-10 tw-min-h-[400px]"
    >
        <!-- Image Card -->
        <div class="tw-w-full lg:tw-w-auto tw-flex tw-justify-center">
            <div
                class="tw-bg-white tw-shadow-md tw-overflow-hidden tw-max-w-[500px] tw-w-full"
            >
                <img
                    #financialAdvisoryImage
                    src="../../../assets/images/About-us/financial-advisory.jpg"
                    alt="Financial Advisory"
                    class="tw-w-full tw-h-[350px] lg:tw-h-[470px] tw-object-cover"
                />
            </div>
        </div>
        <!-- Content Card -->
        <div
            class="tw-w-full tw-max-w-[825px] tw-rounded-[8px] tw-p-6 lg:tw-p-10"
        >
            <h2
                class="tw-w-full !tw-text-[24px] md:!tw-text-[30px] tw-text-[#0F3172] !tw-font-bold !tw-leading-[120%] lg:!tw-leading-[140%]"
            >
                {{ "NEW_FINANCIAL_ADVISORY.TITLE" | translate }}
            </h2>
            <p
                class="tw-text-[#303030] tw-text-[14px] lg:tw-text-[18px] tw-font-normal !tw-mb-5 tw-leading-[27px] lg:!tw-leading-[27px]"
            >
                {{ "NEW_FINANCIAL_ADVISORY.DESC" | translate }}
            </p>
            <ol
                class="tw-list-decimal tw-ml-5 tw-space-y-3 tw-text-[#303030] tw-font-bold tw-text-[18px] lg:tw-text-[18px] tw-leading-[100%]"
            >
                <li class="!tw-mb-5">
                    {{ "NEW_FINANCIAL_ADVISORY.QUE1" | translate }}
                </li>
                <li class="!tw-mb-5">
                    {{ "NEW_FINANCIAL_ADVISORY.QUE2" | translate }}
                </li>
                <li class="!tw-mb-5">
                    {{ "NEW_FINANCIAL_ADVISORY.QUE3" | translate }}
                </li>
            </ol>
        </div>
    </div>

    <!-- About Us Guide -->
    <app-about-us-guide></app-about-us-guide>
</div>

<!-- Footer -->
<app-footer
    (click)="closeMegaMenuCondition()"
    [selectedLanguage]="selectedLanguage"
></app-footer>
